import { createSlice } from "@reduxjs/toolkit";
import { getBranch, submitBranch, deleteBranch, deleteBanner, attachTreatment, attachDoctor, getSetupSchedule, getBranchSchedule } from "./Utils/branchUtils";
import Swal from 'sweetalert2';

const initialState = {
    filters: {
        "filter[id]": "",
        "filter[name]": "",
        "sort": "-id",
        "page": "",
        "include": "",
    },
    branches: [],
    pagination: {},
    loading: false,
    error: null,
    branchSchedule: [],
    branchSetupSchedule: [],

    currentBranch: {  // Ini buat menyimpan data form yang lagi aktif
        id: null,
        name: "",
        location: "",
        phone: "",
        operation_hours: {
            "sunday": "close",
            "monday": "close",
            "tuesday": "close",
            "wednesday": "close",
            "thursday": "close",
            "friday": "close",
            "saturday": "close"
        },
        latitude: "",
        longitude: "",
        photos: null,
        banner:[],
        branch_id: "",
        branch_name: "",
        treatment_id: [],
        doctor_id: [],
    }
};


const branchSlice = createSlice({
    name: "branch",
    initialState,
    reducers: {
        setFormData: (state, action) => {
            state.currentBranch = { ...state.currentBranch, ...action.payload };
        },
        resetFormData: (state) => {
            state.currentBranch = initialState.currentBranch;
        },
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        }
    },
    extraReducers: (builder) => {
        builder
            // Handle getBranch
            .addCase(getBranch.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getBranch.fulfilled, (state, action) => {
                state.loading = false;
                state.branches = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            .addCase(getBranch.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Handle submitBranch (update atau tambah branch)
            .addCase(submitBranch.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(submitBranch.fulfilled, (state, action) => {
                state.loading = false;
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Data Cabang Klinik Berhasil Disimpan',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });

                // Kalau data baru, tambah ke daftar
                if (!state.branches.find(branch => branch.id === action.payload.id)) {
                    state.branches.push(action.payload);
                } else {
                    // Kalau update, replace data lama
                    state.branches = state.branches.map(branch =>
                        branch.id === action.payload.id ? action.payload : branch
                    );
                }

                // Reset form setelah simpan
                state.currentBranch = initialState.currentBranch;
            })
            .addCase(submitBranch.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Handle deleteBranch
            .addCase(deleteBranch.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteBranch.fulfilled, (state, action) => {
                state.loading = false;
                state.branches = state.branches.filter(branch => branch.id !== action.payload.id);
            })
            .addCase(deleteBranch.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Handle deleteBanner
            .addCase(deleteBanner.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteBanner.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                state.currentBranch.id = null;
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Data Berhasil Dihapus',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
            })
            .addCase(deleteBanner.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Handle attachTreatment
            .addCase(attachTreatment.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(attachTreatment.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: `Data Layanan Perawatan Berhasil Ditambahkan ke ${state.currentBranch.branch_name}`,
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                });
            })
            .addCase(attachTreatment.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Handle attachDoctor
            .addCase(attachDoctor.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(attachDoctor.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: `Data Dokter Berhasil Ditambahkan ke ${state.currentBranch.branch_name}`,
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                });
            })
            .addCase(attachDoctor.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Handle getSetupSchedule
            .addCase(getSetupSchedule.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getSetupSchedule.fulfilled, (state, action) => {
                state.loading = false;
                state.branchSetupSchedule = action.payload.data;
            })
            .addCase(getSetupSchedule.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Handle getBranchSchedule
            .addCase(getBranchSchedule.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getBranchSchedule.fulfilled, (state, action) => {
                state.loading = false;
                state.branchSchedule = action.payload.data;
            })
            .addCase(getBranchSchedule.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { setFormData, resetFormData, setFilters } = branchSlice.actions;
export default branchSlice.reducer;